export default "__VITE_ASSET__BfsX_74G__"